<template>
  <v-app id="inspire">
    <AdminSidebar :drawer="drawer"/>
    <AdminTopbar @drawerEvent="drawer = !drawer"/>
    <v-main style="background: #f5f5f540">
      <v-container class="py-8 px-6" fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Sidebar from "./../components/Sidebar";
import Topbar from "./../components/Topbar";
import AdminSidebar from "@/components/AdminSidebar";
import AdminTopbar from "@/components/AdminTopbar";

export default {
  components: {AdminTopbar, AdminSidebar},
  data: () => ({
    cards: ["Today", "Yesterday"],
    drawer: null,
  }),
  methods: {},
  name: "adminLayout"
};
</script>

<style scoped>

</style>